import * as React from 'react'
import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import get from 'lodash/get'
import { useRecordContext, sanitizeFieldRestProps, ImageFieldClasses } from 'react-admin'
import { imageUrlConcat } from '../../utils/url-concat'
import { isBlob } from '../../utils/validators'
import { ImageFieldProps } from './type'

const PREFIX = 'RaImageField'

const Root = styled(Box, {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})({
  [`& .${ImageFieldClasses.list}`]: {
    display: 'flex',
    listStyleType: 'none',
  },
  [`& .${ImageFieldClasses.image}`]: {
    margin: '0.25rem',
    width: 200,
    height: 100,
    objectFit: 'contain',
  },
})

export const ImageField: React.FC<ImageFieldProps> = (props) => {
  const { className, emptyText, source, src, preSrc, title, ...rest } = props
  const record = useRecordContext(props)
  const sourceValue = get(record, source) || preSrc

  if (!sourceValue) {
    return emptyText ? (
      <Typography
        component='span'
        variant='body2'
        className={className}
        {...sanitizeFieldRestProps(rest)}
      >
        {emptyText}
      </Typography>
    ) : (
      <div className={className} {...sanitizeFieldRestProps(rest)} />
    )
  }

  if (Array.isArray(sourceValue)) {
    return (
      <Root className={className} {...sanitizeFieldRestProps(rest)}>
        <ul className={ImageFieldClasses.list}>
          {sourceValue.map((file, index) => {
            const fileTitleValue = get(file, title) || title
            const srcValue = get(file, src) || title

            return (
              <li key={index}>
                <img
                  alt={fileTitleValue}
                  title={fileTitleValue}
                  src={!isBlob(srcValue) ? imageUrlConcat(srcValue) : srcValue}
                  className={ImageFieldClasses.image}
                />
              </li>
            )
          })}
        </ul>
      </Root>
    )
  }

  const titleValue = get(record, title) || title

  return (
    <Root className={className} {...sanitizeFieldRestProps(rest)}>
      <img
        title={titleValue}
        alt={titleValue}
        src={!isBlob(sourceValue) ? imageUrlConcat(sourceValue) : sourceValue}
        className={ImageFieldClasses.image}
      />
    </Root>
  )
}

export const PreviewImage = styled(ImageField)(() => ({
  '& .RaImageField-image': {
    width: 220,
    height: '100%',
    objectFit: 'fill',
    borderRadius: 5,
  },
}))

ImageField.displayName = 'ImageField'
